import React, { Component } from "react";
import { Link } from "react-router-dom";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import "./collection2.css";
import { getRelatedItems } from "../../../services";
import icon from "./G-icon.png";
class ProductItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      cartModalopen: false,
      stock: "InStock",
      quantity: 1,
      image: "",
    };
  }

  onClickHandle(img) {
    this.setState({ image: img });
  }
  onOpenModal = () => {
    this.setState({ open: true });
  };
  onCloseModal = () => {
    this.setState({ open: false });
  };

  onOpenCartModal = () => {
    this.setState({ cartModalopen: true });
    this.props.onAddToCartClicked();
  };
  onCloseCartModal = () => {
    this.setState({ cartModalopen: false });
  };

  minusQty = () => {
    if (this.state.quantity > 1) {
      this.setState({ stock: "InStock" });
      this.setState({ quantity: this.state.quantity - 1 });
    }
  };

  plusQty = () => {
    if (this.props.product.stock >= this.state.quantity) {
      this.setState({ quantity: this.state.quantity + 1 });
    } else {
      this.setState({ stock: "Out of Stock !" });
    }
  };
  changeQty = (e) => {
    this.setState({ quantity: parseInt(e.target.value) });
  };

  getRatingStar = (item) => {
    let RatingStars = [];
    for (let i = 0; i < 5; i++) {
      if (item.rating >= i + 1) {
        // Full star
        RatingStars.push(
          <i
            className="fa fa-star"
            key={i}
            style={{
              color: "#fa4000",
              fontSize: "1em",
              lineHeight: "1em",
              verticalAlign: "middle",
            }}
          />
        );
      } else if (item.rating > i && item.rating < i + 1) {
        // Partial star (show half based on decimal)
        const percentage = (item.rating - i) * 100;
        RatingStars.push(
          <span
            key={i}
            style={{
              position: "relative",
              display: "inline-block",
              width: "1em",
              height: "1em",
              fontSize: "1em",
              lineHeight: "1em",
              verticalAlign: "middle",
            }}
          >
            {/* Gray background star */}
            <i
              className="fa fa-star"
              style={{
                color: "#dddddd",
                position: "absolute",
                left: 0,
                top: 0,
                width: "100%",
                height: "100%",
                lineHeight: "1em",
                fontSize: "1em",
              }}
            />
            {/* Orange partial foreground star */}
            <i
              className="fa fa-star"
              style={{
                color: "#fa4000",
                width: `${percentage}%`,
                overflow: "hidden",
                position: "absolute",
                left: 0,
                top: 0,
                whiteSpace: "nowrap",
                height: "100%",
                lineHeight: "1em",
                fontSize: "1em",
              }}
            />
          </span>
        );
      } else {
        // Empty star
        RatingStars.push(
          <i
            className="fa fa-star"
            key={i}
            style={{
              color: "#dddddd",
              fontSize: "1em",
              lineHeight: "1em",
              verticalAlign: "middle",
            }}
          />
        );
      }
    }
    return RatingStars.length > 0 ? RatingStars : "No Rating";
  };

  render() {
    const {
      product,
      symbol,
      onAddToCartClicked,
      onAddToWishlistClicked,
      onAddToCompareClicked,
      relatedItems,
      currency,
    } = this.props;

    let RatingStars = [];
    for (var i = 0; i < product.rating; i++) {
      RatingStars.push(<i className="fa fa-star" key={i} />);
    }
    const image = product.pictures[0];

    let taka = 0;
    if (currency) {
      taka = currency.taka;
    }

    return (
      <div>
        <div className="product-box product-box-homepage-1">
          <div
            className="img-wrapper img-wrapper-homepage-1"
            style={{
              backgroundImage: `url(${icon})`,
              backgroundColor: "white",
              backgroundSize: "130px 130px",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          >
            <div className="lable-block">
              {product.sale == true ? (
                <span className="lable4">on sale</span>
              ) : (
                ""
              )}
              {product.new == true ? <span className="lable3">new</span> : ""}
            </div>
            <div className="front">
              <Link to={`/product/${product.id}`}>
                <img
                  src={`${
                    image
                      ? `${image.replace("cbu01.alicdn.com", "global-img-cdn.1688.com")}_200x200.webp`
                      : `${process.env.PUBLIC_URL}/assets/images/icon/icon.png`
                  }`}
                  className="img-fluid lazyload bg-img product-only-image"
                  style={{ minWidth: "100%" }}
                  alt=""
                  loading="lazy"
                />
              </Link>
            </div>
            <div className="cart-info cart-wrap" style={{ padding: "5px" }}>
              <Link to={`/product/${product.id}`} title="Add to cart">
                <i
                  className="fa fa-shopping-cart"
                  aria-hidden="true"
                  style={{ fontSize: "10px" }}
                />
              </Link>
              <a
                onClick={onAddToWishlistClicked}
                title="Add to Wishlist"
                style={{ cursor: "pointer" }}
              >
                <i
                  className="fa fa-heart"
                  aria-hidden="true"
                  style={{ fontSize: "10px" }}
                />
              </a>
            </div>
          </div>
          <div
            className="product-detail"
            style={{ padding: "5px", paddingBottom: "80px", paddingTop: "0px" }}
          >
            <div>
              <Link to={`/product/${product.id}`}>
                <h6
                  style={{
                    color: "black",
                    fontSize: "90%",
                    fontWeight: "bold",
                    marginTop: 5,
                    textTransform: "capitalize",
                    whiteSpace: "nowrap", // 🚫 No wrapping
                    overflow: "hidden", // ✂️ Hide overflow
                    textOverflow: "ellipsis", // … Show ellipsis if overflow
                    marginRight: 5,
                    textAlign: "left",
                    paddingBottom: 0,
                  }}
                  className="product-name"
                >
                  {product.name}
                </h6>
              </Link>
              <h6
                style={{
                  color: "#ff4a4e",
                  fontSize: "100%",
                  fontWeight: "bold",
                  marginTop: 0,
                  textAlign: "left",
                }}
                className="product-price"
              >
                ৳{Math.round(parseFloat(product.salePrice) * parseFloat(taka))}{" "}
                <br />
              </h6>
              <div
                style={{ fontSize: "80%", textAlign: "left" }}
                className="product-name"
              >
                Total Sold:{product.totalSold}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                paddingLeft: 5,
                marginTop: 10,
                borderTop: "1px solid gainsboro",
                paddingTop: 5,
              }}
              className="seller-container"
            >
              <div style={{ fontSize: 12, marginTop: 3 }} className="shop-name">
                {this.getRatingStar(product)}
              </div>
              <div
                style={{
                  fontSize: 11,
                  padding: "3px 7px",

                  borderRadius: 4,
                  background:
                    "linear-gradient(90deg, #fda085 0%, #f6d365 100%)",
                  cursor: "pointer",
                  boxShadow: "0 0 8px rgba(253, 160, 133, 0.6)",
                  transition: "all 0.3s ease-in-out",
                }}
                className="view-seller"
              >
                {product.rating ? product.rating : "No Rating"}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  relatedItems: getRelatedItems(state.data.products, ownProps.product.category),
  symbol: state.data.symbol,
  currency: state.user.currency,
});

export default connect(mapStateToProps)(ProductItem);
